import { Link } from 'react-router-dom';
import styled from 'styled-components';
import BlankImage from '../../../../assets/images/blank-image.png';
import { IInformation } from '../../../../interfaces/Information.interfaces';
import { formatDate } from '../../../../utils/formatter/formatDate.util';

interface InfoHorizontalListDetailViewProps {
  information: IInformation;
}

export const InfoHorizontalListDetailView = ({ information }: InfoHorizontalListDetailViewProps) => {
  return (
    <Container to={`/info/${information.id}`}>
      <ThumbnailImage src={information.thumbnailUrl ?? BlankImage} />
      <InfoSection>
        <HeaderContainer>
          {information.category === 'NEWS' && <NewsCategory>{'뉴스'}</NewsCategory>}
          {information.category === 'MAGAZINE' && <InfoCategory>{'매거진'}</InfoCategory>}
          <SplitBar>{'|'}</SplitBar>
          <CreateDate>{formatDate(information.createdAt)}</CreateDate>
        </HeaderContainer>
        <Title>{information.title}</Title>
        <PreviewContent>{information.previewContent}</PreviewContent>
      </InfoSection>
    </Container>
  );
};

const Container = styled(Link)`
  min-width: 300px;
  max-width: 300px;
  height: 385px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  border-radius: var(--radius-medium, 8px);
  background: var(--light-scheme-monochrome-grey-10, #f2f2f7);

  cursor: pointer;
`;

const ThumbnailImage = styled.img`
  width: 300px;
  height: 241px;

  object-fit: cover;

  border-radius: var(--radius-none, 0px);

  border-radius: 8px 8px 0px 0px;
`;

const InfoSection = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: 16px;

  padding: 24px;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  gap: 4px;
`;

const Category = styled.span`
  /* System/Small/s-bold */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 10.2px */
`;

const NewsCategory = styled(Category)`
  color: var(--light-scheme-color-primary-blue, #445eff);
`;

const InfoCategory = styled(Category)`
  color: var(--light-scheme-color-primary-red, #ff3049);
`;

const SplitBar = styled.span`
  color: var(--light-scheme-monochrome-grey-50, #babdca);
  /* System/Small/s-regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 10.2px */
`;

const CreateDate = styled.div`
  color: var(--light-scheme-monochrome-grey-100, #858894);

  /* System/Small/s-regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 10.2px */
`;

const Title = styled.h2`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;

  overflow: hidden;
  color: var(--light-scheme-monochrome-black, #232429);
  text-overflow: ellipsis;

  /* Body/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;

const PreviewContent = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;

  overflow: hidden;
  color: var(--light-scheme-monochrome-offblack, #505363);
  text-overflow: ellipsis;

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;
